// SimulationBanner.js — Persistent amber banner for simulation pages.
// Non-dismissible. Follows EnvironmentBanner pattern from common/index.js.

import React, { useState } from 'react';
import { AlertTriangle, ChevronDown, ChevronUp } from 'lucide-react';

const DISCLOSURE_LINES = [
  'This simulation tool provides illustrative results based on historical data and does not constitute investment advice, a forecast, or a guarantee of future performance.',
  'Past performance is not indicative of future results. Actual outcomes may differ materially from any scenario shown.',
  'All simulations assume successful auction participation and do not account for market liquidity constraints, counterparty risk, or regulatory changes.',
  'Foreign exchange rates, hedging costs, and T-bill yields used are based on historical observations and may not reflect future market conditions.',
  'Withholding tax rates are subject to change based on applicable tax treaties and regulations.',
  'This tool is for educational and illustrative purposes only. Consult your financial advisor before making investment decisions.',
];

export default function SimulationBanner({ mode = 'historical' }) {
  const [expanded, setExpanded] = useState(false);

  const label = mode === 'live' ? 'LIVE SIMULATION' : 'SIMULATION';
  const subtitle = mode === 'live'
    ? 'Running forward from today with real data as it arrives'
    : 'Results based on historical data. Not a forecast or guarantee.';

  return (
    <div className="bg-amber-50 border-b border-amber-200">
      <div className="max-w-7xl mx-auto px-4">
        {/* Main banner */}
        <div className="flex items-center justify-between py-2">
          <div className="flex items-center gap-2">
            <AlertTriangle className="w-4 h-4 text-amber-600 flex-shrink-0" />
            <span className="font-mono text-xs uppercase tracking-[0.15em] font-semibold text-amber-800">
              {label}
            </span>
            <span className="text-xs text-amber-700 hidden sm:inline">
              — {subtitle}
            </span>
          </div>
          <button
            onClick={() => setExpanded(!expanded)}
            className="flex items-center gap-1 text-xs text-amber-600 hover:text-amber-800 transition-colors"
          >
            <span>Disclosure</span>
            {expanded ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />}
          </button>
        </div>

        {/* Expanded disclosure */}
        {expanded && (
          <div className="pb-3 border-t border-amber-200 pt-2">
            <ul className="space-y-1">
              {DISCLOSURE_LINES.map((line, i) => (
                <li key={i} className="text-xs text-amber-700 leading-relaxed">
                  {line}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
